// Mock Construction Data - İNŞA ET
// İnşaat projeleri ve detaylı bilgiler

export const mockConstructions = [
    {
        id: 'c1',
        name: 'Yeşil Park Konutları',
        shortName: 'Yeşil Park',
        parcelInfo: 'Ada: 1234, Parsel: 56',
        address: 'Yeşilköy Mahallesi, Park Caddesi No:15, Bakırköy/İstanbul',
        city: 'İstanbul',
        district: 'Bakırköy',
        startDate: '2025-01-15',
        estimatedEndDate: '2025-12-31',
        estimatedBudget: 15000000,
        actualSpent: 7800000,
        blocks: [
            { name: 'A Blok', floors: 4, apartments: 8, status: 'active' },
            { name: 'B Blok', floors: 4, apartments: 8, status: 'active' },
        ],
        totalFloors: 4,
        status: 'active',
        progress: 65,
        landOwnerShare: 40,
        contractorShare: 60,
        landArea: 1250,
        constructionArea: 2800,
        summary: {
            totalApartments: 16,
            soldApartments: 8,
            reservedApartments: 3,
            emptyApartments: 5,
            totalIncome: 12500000,
            totalExpense: 7800000,
            netBalance: 4700000,
            collectedPayments: 10200000,
            pendingPayments: 2300000,
            overduePayments: 450000,
        },
        contacts: {
            landOwner: {
                name: 'Hüseyin Aktaş',
                phone: '0555 111 11 13',
                email: 'huseyin.aktas@email.com',
            },
            siteManager: {
                name: 'Serkan Yıldırım',
                phone: '0555 111 11 30',
                email: 'serkan.yildirim@email.com',
            },
            architect: {
                name: 'Neslihan Demir',
                phone: '0555 111 11 31',
            },
        },
        permits: {
            buildingPermit: { status: 'approved', date: '2024-12-01', number: 'YP-2024-001' },
            occupancyPermit: { status: 'pending', date: null, number: null },
        },
        milestones: [
            { name: 'Temel Atma', date: '2025-01-15', completed: true },
            { name: 'Kaba İnşaat', date: '2025-04-01', completed: true },
            { name: 'Çatı', date: '2025-06-15', completed: true },
            { name: 'İç İşler', date: '2025-09-01', completed: false },
            { name: 'Teslim', date: '2025-12-31', completed: false },
        ],
        images: {
            cover: null,
            gallery: [],
        },
        notes: 'A Blok teslime yakın. B Blok iç işleri devam ediyor.',
        createdAt: '2025-01-01T10:00:00Z',
        updatedAt: '2026-01-03T15:30:00Z',
    },
    {
        id: 'c2',
        name: 'Global Rezidans',
        shortName: 'Global',
        parcelInfo: 'Ada: 5678, Parsel: 12',
        address: 'Sahil Mahallesi, Deniz Sokak No:45, Kadıköy/İstanbul',
        city: 'İstanbul',
        district: 'Kadıköy',
        startDate: '2025-06-01',
        estimatedEndDate: '2026-06-30',
        estimatedBudget: 28000000,
        actualSpent: 12000000,
        blocks: [
            { name: 'A Blok', floors: 6, apartments: 12, status: 'active' },
            { name: 'B Blok', floors: 6, apartments: 12, status: 'active' },
            { name: 'C Blok', floors: 6, apartments: 12, status: 'planning' },
        ],
        totalFloors: 6,
        status: 'active',
        progress: 43,
        landOwnerShare: 35,
        contractorShare: 65,
        landArea: 2100,
        constructionArea: 5400,
        summary: {
            totalApartments: 36,
            soldApartments: 18,
            reservedApartments: 8,
            emptyApartments: 10,
            totalIncome: 25000000,
            totalExpense: 12000000,
            netBalance: 13000000,
            collectedPayments: 20500000,
            pendingPayments: 4500000,
            overduePayments: 800000,
        },
        contacts: {
            landOwner: {
                name: 'Kemal Erdoğan',
                phone: '0555 111 11 17',
                email: 'kemal.erdogan@email.com',
            },
            siteManager: {
                name: 'Volkan Arslan',
                phone: '0555 111 11 32',
                email: 'volkan.arslan@email.com',
            },
            architect: {
                name: 'Pınar Özkan',
                phone: '0555 111 11 33',
            },
        },
        permits: {
            buildingPermit: { status: 'approved', date: '2025-05-15', number: 'MD-2025-001' },
            occupancyPermit: { status: 'pending', date: null, number: null },
        },
        milestones: [
            { name: 'Temel Atma', date: '2025-06-01', completed: true },
            { name: 'Kaba İnşaat', date: '2025-10-01', completed: true },
            { name: 'Çatı', date: '2026-01-15', completed: false },
            { name: 'İç İşler', date: '2026-04-01', completed: false },
            { name: 'Teslim', date: '2026-06-30', completed: false },
        ],
        images: {
            cover: null,
            gallery: [],
        },
        notes: 'Premium rezidans projesi. Deniz manzaralı daireler yoğun ilgi görüyor.',
        createdAt: '2025-05-15T09:00:00Z',
        updatedAt: '2026-01-03T11:45:00Z',
    },
];

// Helper functions
export const getConstructionById = (id) => {
    return mockConstructions.find(c => c.id === id) || null;
};

export const getConstructionStats = () => {
    const total = mockConstructions.length;
    const active = mockConstructions.filter(c => c.status === 'active').length;
    const completed = mockConstructions.filter(c => c.status === 'completed').length;
    const planning = mockConstructions.filter(c => c.status === 'planning').length;

    const totalApartments = mockConstructions.reduce((sum, c) => sum + (c.summary?.totalApartments || 0), 0);
    const soldApartments = mockConstructions.reduce((sum, c) => sum + (c.summary?.soldApartments || 0), 0);
    const totalBudget = mockConstructions.reduce((sum, c) => sum + (c.estimatedBudget || 0), 0);
    const totalSpent = mockConstructions.reduce((sum, c) => sum + (c.actualSpent || 0), 0);

    return {
        total,
        active,
        completed,
        planning,
        totalApartments,
        soldApartments,
        totalBudget,
        totalSpent,
    };
};

export default mockConstructions;
